import cn from 'classnames';
import { AiOutlineDelete, AiOutlineEdit } from 'react-icons/ai';
import { TbRestore } from 'react-icons/tb';
import { Card } from '../../../../../../components/card/card';
import { IconButton } from '../../../../../../components/icon-button/icon-button';
import { Table } from '../../../../../../features/table/table';
import { TableFilterDateTimeRange } from '../../../../../../features/table/table-filter/table-filter-date-time-range/table-filter-date-time-range';
import { TableFilterInput } from '../../../../../../features/table/table-filter/table-filter-input/table-filter-input';
import { TableFilterRange } from '../../../../../../features/table/table-filter/table-filter-range/table-filter-range';
import { formatRuDateTimeString } from '../../../../../../helpers/date-time';
import { useLang } from '../../../../../../hooks/use-lang';
import { useModalParams } from '../../../../../../hooks/use-modal-params';
import { useQueryParams } from '../../../../../../hooks/use-query-params';
import { useBranchesStore } from '../../../../../../store/use-branch-store';
import s from './branches-table.module.css';

export const BranchesTable = () => {
  const { place, isLoadingFetch } = useBranchesStore();

  const { t, getLocale } = useLang();
  const { addQueryParams } = useQueryParams();

  const editBranchModal = useModalParams('editBranch');
  const archiveBranchModal = useModalParams('archiveBranch');

  return (
    <Card>
      <Table
        id="branch-list"
        columnSettings
        frontPagination
        withArchive
        isLoading={isLoadingFetch}
        className={s.table}
        onEmpty={{
          title: t('Не создано ни одного филиала'),
          text: t('Создайте первый филиал с помощью кнопки выше'),
        }}
        cols={{
          name: {
            label: t('Название'),
            filter: (
              <TableFilterInput
                name="name"
                suggestOptions={place?.map((item) => getLocale(item.name))}
              />
            ),
          },
          staff_count: {
            label: t('Кол-во сотрудников'),
            filter: <TableFilterRange name="staff_count" />,
          },
          description: {
            label: t('Описание'),
            filter: (
              <TableFilterInput
                name="description"
                suggestOptions={place?.map((item) => getLocale(item.description))}
              />
            ),
          },
          zip: {
            label: t('Индекс'),
            filter: (
              <TableFilterInput name="zip" suggestOptions={place?.map((item) => item.zip || '')} />
            ),
          },
          address: {
            label: t('Адрес'),
            filter: (
              <TableFilterInput
                name="address"
                suggestOptions={place?.map((item) => getLocale(item.address))}
              />
            ),
          },
          phone: {
            label: t('Телефон'),
            filter: (
              <TableFilterInput
                name="phone"
                suggestOptions={place?.map((item) => item.phone || '')}
              />
            ),
          },
          createdAt: {
            label: t('Создан'),
            filter: <TableFilterDateTimeRange name="created_at" />,
          },
          actions: { label: t('Действия') },
        }}
        rows={place?.map((item) => ({
          className: cn(item.is_deleted && s.disabled),
          name: <div style={{ opacity: item.is_deleted ? 0.5 : 1 }}>{getLocale(item.name)}</div>,
          staff_count: item.staff_count || 0,
          description: getLocale(item.description),
          zip: item.zip,
          address: getLocale(item.address),
          phone: item.phone,
          createdAt: formatRuDateTimeString(item.created_at),
          actions: (
            <div className={s.actions}>
              {item.is_deleted ? (
                <IconButton
                  tooltip={t('Восстановить')}
                  variant="secondary"
                  size="sm"
                  onClick={() =>
                    addQueryParams({
                      restoreId: String(item.id),
                      restoreName: getLocale(item.name),
                    })
                  }
                >
                  <TbRestore />
                </IconButton>
              ) : (
                <>
                  <IconButton
                    tooltip={t('Редактировать')}
                    variant="secondary"
                    size="sm"
                    onClick={() => editBranchModal.handleOpenModal({ branchId: item.id })}
                  >
                    <AiOutlineEdit />
                  </IconButton>
                  <IconButton
                    tooltip={t('Архивировать')}
                    size="sm"
                    variant="danger"
                    onClick={() =>
                      archiveBranchModal.handleOpenModal({
                        branchId: item.id,
                        branchName: getLocale(item.name),
                      })
                    }
                  >
                    <AiOutlineDelete />
                  </IconButton>
                </>
              )}
            </div>
          ),
        }))}
      />
    </Card>
  );
};
